import axios from "axios";
import { z } from "zod";
import { errorLog } from "../../../logger";
import { parsePaginationHeaders } from "../../utils/parsePaginationHeaders";
import { stringifyQueryParams } from "../../utils/stringifyQueryParams";
import ValidationError from "../../ZodError";
import { TaskComment } from "../Types";
import { taskCommentsUrl } from "./urls";
const GetTaskCommentsResponse = z.object({
    values: TaskComment.array(),
});
export default async function getTaskComments(taskId, config, queryParams) {
    const { data, headers } = await axios.get(taskCommentsUrl(taskId), {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            Advisor: config.advisorId,
        },
        params: queryParams,
        paramsSerializer: {
            serialize: (params) => stringifyQueryParams(params),
        },
    });
    const decoded = GetTaskCommentsResponse.safeParse(data);
    if (decoded.success) {
        return {
            values: decoded.data.values,
            pagination: parsePaginationHeaders(headers),
        };
    }
    else {
        const errorMessage = "[getTaskComments] returned unexpected data.";
        errorLog(getTaskComments.name, JSON.stringify(decoded.error.issues));
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=getTaskComments.js.map